import jobListBinding from './bind'
import bookmarkBind from 'bookmarks/bind'
import EventBus from 'event_bus'
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'

export default class JobListShowMore {
  constructor ($el, $link) {
    this.$el = $el
    this.$content = $el.find('.js-job-list-content')
    this.$link = $link
    this.$jobShowMore = this.$link.parent()
    this.url = this.$link.data('load-more-url')
    this.xhrRunning = false
    this.addEventListeners()
  }

  addEventListeners () {
    this.$link.on('click', (event) => {
      event.preventDefault()
      this.loadMoreJobs()
    })

    if (this.url) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting }) => {
          if (isIntersecting) {
            this.loadMoreJobs()
          }
        })
      }, {
        rootMargin: '600px',
        root: MediaQuery.is('large') ? this.$content.get(0) : undefined
      })
      this.observer.observe(this.$jobShowMore.get(0))
    }
  }

  removeEventListeners () {
    this.observer.disconnect()
  }

  loadMoreJobs () {
    if (this.xhrRunning) { return }

    this.xhrRunning = true

    $.ajax({
      cache: false,
      method: 'GET',
      url: this.url,
      dataType: 'json'
    }).done((response) => {
      this.xhrRunning = false
      this.$content.append(response.body)
      this.$jobShowMore.remove()
      this.removeEventListeners()
      bookmarkBind(this.$content)
      EventBus.trigger('bookmarks:replay', null)
      EventBus.trigger('tracking:pageload', response.webtrekk)
      jobListBinding()
    })
  }
}
